import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import { developAxios } from "../axios.config";

export default function EditSubTopics() {
	const [course, setCourse] = useState("");
	const [courses, setCourses] = useState([]);

	const [topicCount, setTopicCount] = useState([
		{
			name: "",
			totalSubTopics: 0,
			subTopics: [
				{
					name: "",
					status: "",
				},
			],
		},
	]);

	function handleNestedEventChange(index, nested_index, e, event_name) {
		let topics = [...topicCount];
		topics[index]["subTopics"][nested_index][event_name] = e.target.value;
		setTopicCount(topics);
	}

	function handleEventChange(index, e, event_name) {
		let topics = [...topicCount];
		topics[index][event_name] = e.target.value;
		setTopicCount(topics);
	}

	useEffect(() => {
		console.log(topicCount);
	}, [topicCount]);

	/**
	 *
	 * @param {number} index
	 * @param {string} action
	 */
	function topicsAction(index, action) {
		let topics = [...topicCount];
		switch (action) {
			case "remove":
				topics.splice(index, 1);
				break;

			case "add":
				topics.push({
					name: "",
					totalSubTopics: 0,
					subTopics: [
						{
							name: "",
							status: "",
						},
					],
				});
				break;

			default:
				console.alert("action does not exist");
		}

		setTopicCount(topics);
	}

	function submitData() {
		if (course == "") return;
		developAxios(localStorage.getItem("token"))
			.post("/addTopics", {
				courseId: course,
				topics: topicCount,
			})
			.then(({ data }) =>
				alert("topics successfully added to the database")
			)
			.catch((err) => alert("Error in adding to the database"));
	}

	useEffect(() => {
		fetch(BASE_URL + "/getallcourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
			})
			.catch((err) => console.log(err));
	}, []);

	useEffect(() => {
		if (course == "") return;

		let result = courses.filter(
			(course_param) => course_param._id == course
		);

		if (result[0].topics.length == 0) return;

		setTopicCount(result[0].topics);
	}, [course, courses]);

	return (
		<div className="m-5 p-5">
			<h2 style={{ textAlign: "center" }}>Add/Edit Sub Topics</h2>
			<h4>Course Id:</h4>{" "}
			<select
				className={`form-control`}
				aria-label="Default select example"
				name="course_select"
				id="course_select"
				onChange={(e) => {
					setCourse(e.target.value);
				}}
			>
				<option value="">Select Course</option>
				{courses.map((val) => {
					return (
						<option value={val?._id} key={val.id}>
							{val?.name}
						</option>
					);
				})}
			</select>
			<hr />
			{topicCount.map((val, index) => {
				return (
					<div key={`topic_values_${index}`}>
						<label htmlFor="topic_name">
							<h3 style={{ display: "inline-block" }}>
								TOPIC NAME:
							</h3>
							<button
								className="btn btn-success border rounded"
								onClick={() => topicsAction(index, "add")}
							>
								+
							</button>
							<button
								className="btn btn-danger border rounded"
								onClick={() => topicsAction(index, "remove")}
							>
								-
							</button>
						</label>
						<input
							type="text"
							name="topic_name"
							id="topic_name"
							value={val.name}
							onChange={(e) =>
								handleEventChange(index, e, "name")
							}
						/>
						<label htmlFor="total_subTopics">
							Total Sub Topics:
						</label>
						<input
							type="number"
							name="total_subTopics"
							id="total_subTopics"
							value={val.totalSubTopics}
							onChange={(e) =>
								handleEventChange(index, e, "totalSubTopics")
							}
						/>
						<br />
						<br />
						{val.subTopics.map((nested_val, nested_index) => {
							return (
								<>
									<label htmlFor="subtopic_name">
										<h5 style={{ display: "inline-block" }}>
											Sub topic name:
										</h5>
										<button
											className="btn btn-danger border rounded"
											onClick={() => {
												let topics = [...topicCount];
												topics[index][
													"subTopics"
												].splice(nested_index, 1);
												setTopicCount(topics);
											}}
										>
											-
										</button>
									</label>
									<input
										type="text"
										name="subtopic_name"
										id="subtopic_name"
										value={nested_val.name}
										onChange={(e) => {
											handleNestedEventChange(
												index,
												nested_index,
												e,
												"name"
											);
										}}
									/>
									<p>Status:</p>
									<div className="d-flex">
										<div className="px-2 text-danger">
											<input
												type="radio"
												id={`pending_${nested_index}_${index}`}
												name={`topic_status_${nested_index}_${index}`}
												value="pending"
												onChange={(e) =>
													handleNestedEventChange(
														index,
														nested_index,
														e,
														"status"
													)
												}
												checked={
													nested_val.status ===
													"pending"
												}
											/>
											<label
												htmlFor={`pending_${nested_index}_${index}`}
											>
												Pending
											</label>
											<br />
										</div>
										<div className="px-2 text-warning">
											<input
												type="radio"
												id={`ongoing_${nested_index}_${index}`}
												name={`topic_status_${nested_index}_${index}`}
												value="ongoing"
												onChange={(e) =>
													handleNestedEventChange(
														index,
														nested_index,
														e,
														"status"
													)
												}
												checked={
													nested_val.status ===
													"ongoing"
												}
											/>
											<label
												htmlFor={`ongoing_${nested_index}_${index}`}
											>
												On Going
											</label>
											<br />
										</div>
										<div className="px-2 text-success">
											<input
												type="radio"
												id={`completed_${nested_index}_${index}`}
												name={`topic_status_${nested_index}_${index}`}
												value="completed"
												onChange={(e) =>
													handleNestedEventChange(
														index,
														nested_index,
														e,
														"status"
													)
												}
												checked={
													nested_val.status ===
													"completed"
												}
											/>
											<label
												htmlFor={`completed_${nested_index}_${index}`}
											>
												completed
											</label>
										</div>
									</div>
								</>
							);
						})}
						<button
							className="p-2 btn-primary border rounded"
							onClick={(e) => {
								let topics_var = [...topicCount];
								topics_var[index]["subTopics"].push({
									name: "",
									status: "",
								});

								setTopicCount(topics_var);
							}}
						>
							Add Sub Topic
						</button>
						<hr />
					</div>
				);
			})}
			<button className="btn btn-success p-2 m-5" onClick={submitData}>
				SUBMIT ALL
			</button>
		</div>
	);
}
